module.exports = __webpack_public_path__ + "static/media/home-background.4f1111f4.svg";